export const debugEnabled = global.location?.search?.substr(1)?.split('&')?.some(searchParam => {
  const [key, value] = searchParam.split('=')
  return decodeURIComponent(key) === 'adsDebug' && (value === true || value === 'all' || decodeURIComponent(value).split(',').includes('tcfv2'))
})

export function createLog () {
  return debugEnabled ? (...args) => console.log('[mol-ads-cmp]', ...args) : () => {}
}
